import { render, staticRenderFns } from "./qFooter.vue?vue&type=template&id=1c6078f4&"
import script from "./qFooter.vue?vue&type=script&lang=ts&"
export * from "./qFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports